import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type RfqQuoteFinalizeParamsDTO = {
  uuid: string
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqQuoteFinalizeMutation = () =>
  useMutation<any, ErrorDTO, RfqQuoteFinalizeParamsDTO>({
    mutationFn: async (params: RfqQuoteFinalizeParamsDTO) => {
      try {
        const res = await client.put(`/rfq/quote/finalize/${params.uuid}`)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
